import { getProductStructuredData } from './productStructuredData';

export const seoData = {
  home: {
    title: 'IPSE - Soluciones Empresariales | Software ERP, Facturación Electrónica y Gestión Médica',
    description: 'IPSE ofrece soluciones empresariales integrales: QuickCont ERP, Facelec facturación electrónica y Galenos Web gestión médica. Más de 1500 clientes confían en nosotros en Ecuador.',
    keywords: 'software empresarial Ecuador, ERP Ecuador, facturación electrónica, sistema contable, gestión médica, QuickCont, Facelec, Galenos Web, IPSE, soluciones empresariales',
    url: '/',
    favicon: '/ipse-favicon.ico',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "IPSE",
      "url": "https://ipse.com.ec",
      "description": "Soluciones empresariales integrales para la gestión de tu negocio",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://ipse.com.ec/products?q={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    }
  },
  
  about: {
    title: 'Acerca de IPSE - Expertos en Software Empresarial desde 2019 | Ecuador',
    description: 'Conoce la historia de IPSE, empresa ecuatoriana especializada en desarrollo de software empresarial. Más de 5 años de experiencia y 1500+ clientes satisfechos.',
    keywords: 'IPSE empresa, software Ecuador, historia IPSE, desarrollo software empresarial, equipo IPSE, experiencia software',
    url: '/about',
    favicon: '/ipse-favicon.ico',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Acerca de IPSE",
      "description": "Historia y misión de IPSE, empresa líder en soluciones de software empresarial"
    }
  },

  products: {
    title: 'Productos IPSE - QuickCont, Facelec y Galenos Web | Software Empresarial Ecuador',
    description: 'Descubre nuestros productos: QuickCont sistema ERP, Facelec facturación electrónica y Galenos Web gestión médica. Soluciones integrales para tu empresa.',
    keywords: 'productos IPSE, QuickCont ERP, Facelec facturación, Galenos Web médico, software empresarial Ecuador, productos software',
    url: '/products',
    favicon: '/ipse-favicon.ico',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Productos IPSE",
      "description": "Catálogo completo de soluciones de software empresarial"
    }
  },

  contact: {
    title: 'Contacto IPSE - Solicita Información | Guayaquil, Ecuador',
    description: 'Contáctanos para solicitar información sobre nuestras soluciones empresariales. Oficina en Guayaquil, Ecuador. Teléfono: +593 97 965 2188',
    keywords: 'contacto IPSE, información software, consultoría empresarial, Guayaquil Ecuador, teléfono IPSE, oficina IPSE',
    url: '/contact',
    favicon: '/ipse-favicon.ico',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contacto IPSE",
      "description": "Información de contacto y formulario para consultas"
    }
  },

  // Productos específicos
  quickcont: {
    title: 'QuickCont - Sistema ERP Integral | Contabilidad, Facturación e Inventario | IPSE',
    description: 'QuickCont es un sistema ERP completo que integra contabilidad, facturación electrónica, inventario, nómina y más. Con IA integrada y reportes en tiempo real.',
    keywords: 'QuickCont, sistema ERP Ecuador, software contable, facturación electrónica, inventario, nómina, reportes financieros, sistema integral',
    url: '/quickcont',
    image: '/quickcont-og.jpg',
    favicon: '/quickcont-favicon.ico',
    structuredData: getProductStructuredData('quickcont')
  },

  facelec: {
    title: 'Facelec - Facturación Electrónica SRI Ecuador | Cumple Normativas | IPSE',
    description: 'Facelec es la solución completa para facturación electrónica que cumple con todas las normativas del SRI. Integración con sistemas contables y reportes automáticos.',
    keywords: 'Facelec, facturación electrónica Ecuador, SRI normativas, facturación SRI, comprobantes electrónicos, facturación automática',
    url: '/facelec',
    image: '/facelec-og.jpg',
    favicon: '/facelec-favicon.ico',
    structuredData: getProductStructuredData('facelec')
  },

  galenos: {
    title: 'Galenos Web - Sistema Médico Integral | Gestión Clínicas y Consultorios | IPSE',
    description: 'Galenos Web es un sistema integral para gestión de clínicas y consultorios médicos. Historias clínicas, citas, facturación médica y reportes especializados.',
    keywords: 'Galenos Web, sistema médico, gestión clínica, consultorio médico, historia clínica electrónica, citas médicas, facturación médica',
    url: '/galenos',
    image: '/galenos-og.jpg',
    favicon: '/galenos-favicon.ico',
    structuredData: getProductStructuredData('galenos')
  }
};

export const getPageSEO = (page: keyof typeof seoData) => {
  return seoData[page] || seoData.home;
};
